import './apps/tv3/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
